import { useContext } from 'react';

import { GlobalLoadingContext } from 'contexts/GlobalLoadingContext';

export const useGlobalLoading = () => {
  const globalLoadingContext = useContext(GlobalLoadingContext);

  return globalLoadingContext;
};
